<template>
    <div class="warehouse-entry-list">
        <PageHeader title="入库管理" hidden-breadcrumb>
            <Button slot="action" class="ivu-ml" @click="onFillOrder">入库单补录</Button>
            <Button slot="action" class="ivu-ml" @click="onExport" :loading="loadings.export"> 导出订单 </Button>
        </PageHeader>
        <Card :bordered="false" dis-hover class="ivu-mt">
            <table-form :formList="formList" @on-submit="onSubmit" ref="table-form" />
            <Alert show-icon closable class="com-alert">
                审核未通过
                <span style="color: red; padding: 0 5px">{{ failedNum || '-' }}</span>
                条 / 待审核
                <span style="color: #ee9900; padding: 0 5px">{{ auditNum || '-' }}</span>
                条 / 审核通过
                <span style="color: green; padding: 0 5px">{{ passNum || '-' }}</span>
                条
            </Alert>
            <div class="flex-vc mb-10">
                <Button type="primary" @click="onBatchExport" :loading="loadings.batchExport"> 批量导出胎号 </Button>
                <p class="ml-10">
                    已选择
                    <b> {{ selectedData.length }} </b>条
                    <a class="ivu-ml" @click="handleClearSelect">清空</a>
                </p>
            </div>
            <table-page
                class="table-s"
                disHover
                @onPageChange="onPageChange"
                @onPageSizeChange="onPageSizeChange"
                @handleSelect="handleSelect"
                @handleSelectCancel="handleSelectCancel"
                @handleSelectAll="handleSelectAll"
                @handleSelectAllCancel="handleSelectAllCancel"
                :list="list"
            />
        </Card>
        <FillOrder ref="FillOrder" />
        <TypeEdit @getData="getData" ref="typeEdit" />
    </div>
</template>

<script>
import tablePage from '@/components/tablePage';
import tableForm from '@/components/tableForm';
import {
    WareHouseEntryList,
    WareHouseEntryEdit,
    WareHouseEntryExport,
    outboundCount,
    apiBatchBarcodeExport,
    apiOutboundWarehouseList,
} from '@/api/warehouse.js';
import { renderButton, jumpPage } from '@/libs/util';
import FillOrder from '../components/FillOrder';
import TypeEdit from '../components/TypeEdit';
import { clearInvalidKey } from '@/libs/util.tool';

export default {
    components: { tableForm, tablePage, FillOrder, TypeEdit },
    data() {
        return {
            selectedData: [],
            auditNum: '-',
            failedNum: '-',
            passNum: '-',
            orderVisible: false,
            loadings: {
                export: false,
                batchExport: false,
            },
            list: {
                current: 1,
                size: window.$pageSize,
                total: 0,
                columns: [
                    { type: 'selection', width: 60, fixed: 'left' },
                    { title: '出库单号', key: 'sn', minWidth: 180, fixed: 'left' },
                    {
                        title: '销售单号',
                        key: 'salesOrderSn',
                        minWidth: 180,
                        render: (h, p) => {
                            return h('div', p.row.salesOrderSn || '-');
                        },
                    },
                    {
                        title: '分销采购单号',
                        key: 'distributionOrderSn',
                        minWidth: 180,
                        render: (h, p) => {
                            return h('div', p.row.distributionOrderSn || '-');
                        },
                    },
                    {
                        title: '订单类型',
                        key: 'type',
                        minWidth: 100,
                        render: (h, p) => {
                            return <p>{p.row.type === 1 ? '直发订单' : '普通订单'}</p>;
                        },
                    },
                    { title: '数量', key: 'totalQuantity', minWidth: 80 },
                    {
                        title: '审核状态',
                        key: 'type',
                        minWidth: 160,
                        render: (h, p) => {
                            let badge = h('Badge', {
                                props: {
                                    status: {
                                        '': 'default',
                                        0: 'default',
                                        1: 'processing',
                                        2: 'success',
                                        3: 'error',
                                    }[p.row.status],
                                    text: {
                                        '': '-',
                                        0: '-',
                                        1: '待审核',
                                        2: '审核通过',
                                        3: '审核未通过',
                                    }[p.row.status],
                                },
                            });
                            let info =
                                p.row.status === 3
                                    ? h('Icon', {
                                          class: 'reason-modal',
                                          props: {
                                              type: 'ios-information-circle',
                                              size: 19,
                                          },
                                          on: {
                                              click: () => {
                                                  this.$Modal.warning({
                                                      title: '驳回原因',
                                                      content: p.row.reason,
                                                      closable: true,
                                                      okText: '关闭',
                                                  });
                                              },
                                          },
                                      })
                                    : null;
                            return h('div', [badge, info]);
                        },
                    },
                    { title: '地址', key: 'receiveAddress', minWidth: 280 },
                    {
                        title: '仓库',
                        key: 'warehouseSn',
                        minWidth: 160,
                        render: (h, p) => {
                            if (!p.row.warehouseSn) {
                                return h('div', {}, '-');
                            }
                            return h('div', {}, [
                                h('span', {}, p.row.warehouseSn),
                                h('span', { style: { color: '#ddd', display: 'inline-block', padding: '0 7px' } }, '|'),
                                h('span', {}, p.row.warehouseName),
                            ]);
                        },
                    },
                    {
                        title: '仓库类型',
                        key: 'isTotal',
                        minWidth: 100,
                        render: (h, p) => {
                            return h('div', p.row.isTotal ? '总仓' : p.row.isTotal == null ? ' -' : '分仓');
                        },
                    },
                    {
                        title: '操作',
                        key: 'oprate',
                        width: 180,
                        fixed: 'right',
                        render: (h, p) => {
                            return (
                                <div>
                                    {renderButton(h, { text: '详情', type: 'primary' }, () => {
                                        this.detail(p.row);
                                    })}
                                    {p.row.type === 0 &&
                                        renderButton(
                                            h,
                                            {
                                                text: '变更类型',
                                                type: 'warning',
                                                disabled: p.row.status === 1 || p.row.status === 2,
                                            },
                                            () => {
                                                this.changeType(p.row);
                                            },
                                        )}
                                </div>
                            );
                        },
                    },
                ],
                /****
                 * 初始状态且是普通订单则显示变更类型
                 * 审核中或直发订单则不显示变更类型
                 */
                data: [],
                loading: false,
            },
            formList: [
                {
                    title: '订单类型',
                    type: 'select',
                    key: 'type',
                    clearable: true,
                    options: [
                        { id: 0, name: '普通入库单' },
                        { id: 1, name: '直发入库单' },
                    ],
                },
                { title: '出库单号', type: 'input', key: 'sn' },
                { title: '销售单号', type: 'input', key: 'salesOrderSn' },
                { title: '分销采购单号', type: 'input', key: 'distributionOrderSn' },
                { title: '工厂出库时间', type: 'daterange', key: ['beginDate', 'endDate'], width: 300 },
                {
                    title: '审核状态',
                    type: 'select',
                    key: 'status',
                    clearable: true,
                    options: [
                        { id: 1, name: '待审核' },
                        { id: 2, name: '审核通过' },
                        { id: 3, name: '审核未通过' },
                    ],
                },
                {
                    title: '仓库',
                    type: 'select',
                    key: 'warehouseId',
                    clearable: true,
                    options: [],
                },
            ],
        };
    },
    activated() {
        this.getWarehouseList();
        this.list.current = 1;
        let form = this.$refs['table-form'].getFormData();
        this.getData(form);
    },
    methods: {
        // 获取仓库列表
        async getWarehouseList() {
            const res = await apiOutboundWarehouseList();
            this.formList[6].options = res.map((item) => {
                return {
                    id: item.id,
                    name: `${item.sn} | ${item.name}`,
                };
            });
        },
        // 批量导出胎号
        async onBatchExport() {
            const len = this.selectedData.length;
            if (len === 0) {
                this.$Message.error('请勾选出库单');
                return;
            }
            if (len > 50) {
                this.$Message.warning('最多选择50条');
                return;
            }
            try {
                this.loadings.batchExport = true;
                this.$Message.loading({ content: '导出中...', duration: 0 });
                await apiBatchBarcodeExport({ snList: this.selectedData.map((item) => item.sn) });
                this.loadings.batchExport = false;
                this.$Message.destroy();
                this.$Modal.confirm({
                    title: '提示',
                    content: `您好！“${this.$route.meta.title}-批量导出胎号”正在导出，请稍后在“导出列表”模块中查看，谢谢！`,
                    onOk: () => {
                        console.log('batchExport');
                    },
                });
            } catch (error) {
                this.loadings.batchExport = false;
                this.$Message.destroy();
            }
        },
        // 选中一项，将数据添加至已选项中
        handleSelect(selection, row) {
            this.selectedData.push(row);
        },
        // 取消选中一项，将取消的数据从已选项中删除
        handleSelectCancel(selection, row) {
            const index = this.selectedData.findIndex((item) => item.sn === row.sn);
            this.selectedData.splice(index, 1);
        },
        // 当前页全选时，判断已选数据是否存在，不存在则添加
        handleSelectAll(selection) {
            selection.forEach((item) => {
                if (this.selectedData.findIndex((i) => i.sn === item.sn) < 0) {
                    this.selectedData.push(item);
                }
            });
        },
        // 取消当前页全选时，将当前页的数据（即 dataWithPage）从已选项中删除
        handleSelectAllCancel() {
            const selection = this.list.data;
            selection.forEach((item) => {
                const index = this.selectedData.findIndex((i) => i.sn === item.sn);
                if (index >= 0) {
                    this.selectedData.splice(index, 1);
                }
            });
        },
        // 清空所有已选项
        handleClearSelect() {
            this.selectedData = [];
            this.list.data = (this.list.data || []).map((item) => {
                return {
                    ...item,
                    _checked: false,
                };
            });
        },
        getData(p) {
            this.list.loading = true;
            let params = {
                current: this.list.current,
                size: this.list.size,
                ...p,
            };
            WareHouseEntryList(clearInvalidKey(params))
                .then((res) => {
                    this.list.total = Number(res.total);
                    // 判断是否有选中的数据
                    const selectedSns = this.selectedData.map((item) => item.sn);
                    this.list.data = (res.list || []).map((item) => {
                        return {
                            ...item,
                            receiveAddress: item.receiveAddress || '-',
                            source: '出库导入',
                            isShowMore: false,
                            items: [],
                            stockOutSn: item.sn,
                            _checked: selectedSns.indexOf(item.sn) >= 0,
                        };
                    });
                    this.list.loading = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.list.loading = false;
                });
            outboundCount().then(
                (res) => {
                    const { auditNum, failedNum, passNum } = res;
                    this.auditNum = auditNum;
                    this.failedNum = failedNum;
                    this.passNum = passNum;
                },
                () => {
                    this.auditNum = 0;
                    this.failedNum = 0;
                    this.passNum = 0;
                },
            );
        },
        onPageChange(val) {
            this.list.current = val;
            let form = this.$refs['table-form'].getFormData();
            this.getData(form);
        },
        onPageSizeChange(val) {
            this.list.current = 1;
            this.list.size = val;
            let form = this.$refs['table-form'].getFormData();
            this.getData(form);
        },
        onSubmit(params) {
            this.list.current = 1;
            this.getData(params);
        },
        detail(row) {
            jumpPage({
                path: '/sub-vue2/warehouse/entry/edit',
                params: { id: row.outboundId, stockOutSn: row.stockOutSn },
            });
        },
        showDetail(row) {
            row.isShowMore = !row.isShowMore;
            if (row.isShowMore && row.items.length === 0) {
                WareHouseEntryEdit(row.id).then((data) => {
                    row.items = data.items || [];
                });
            }
        },
        changeType(row) {
            this.$refs['typeEdit'].open('EDIT', row);
        },
        onFillOrder() {
            this.$refs['FillOrder'].open();
        },
        async onExport() {
            let form = this.$refs['table-form'].getFormData();
            let params = {
                current: this.list.current,
                size: this.list.total,
                ...form,
            };
            try {
                this.loadings.export = true;
                this.$Message.loading({ content: '导出中...', duration: 0 });
                await WareHouseEntryExport(clearInvalidKey(params));
                this.loadings.export = false;
                this.$Message.destroy();
                this.$Modal.confirm({
                    title: '提示',
                    content: `您好！“${this.$route.meta.title}”正在导出，请稍后在“导出列表”模块中查看，谢谢！`,
                    onOk: () => {
                        console.log('export');
                    },
                });
            } catch (error) {
                this.loadings.export = false;
                this.$Message.destroy();
            }
        },
    },
};
</script>

<style scoped lang="less">
.reason-modal {
    cursor: pointer;
}
</style>
